import { Box, Container, styled, Typography } from "@mui/material";

export const FilterContainer = styled(Box)`
  position: relative;
  display: flex;
  justify-content: end;
  height: 3rem;
  margin: 0.4rem 0rem;
`;
export const DropDownContainer = styled(Typography)`
  max-height: 10rem;
  background: #fff;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const StyledGrayBox = styled(Typography)(({ theme }) => ({
  padding: "10px",
  background: theme.palette.secondary.main,
  cursor: "pointer",
  fontSize: "1rem",
  margin: "0.4rem 0.5rem",
  alignItems: "center",
  height: "3rem",
  display: "flex",
  justifyContent: "center",
  textTransform: "capitalize",
  [theme.breakpoints.down("sm")]: {
    padding: "2px  5px ",
    height: "2rem",
    margin: "0.4rem 0.5rem 0 0",
  },
}));

export const StyledYellowBox = styled(Typography)(({ theme }) => ({
  padding: "0px 5px",
  background: "#ff8400",
  fontSize: "0.6rem",
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "2px",
  },
}));

export const StyledEmptyContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 0rem;
`;

export const StyledCategoryFilterContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-stransform: capitalize;
`;
